<script setup lang="ts">
import type {
	TFilterObject,
	TPagination,
	TTeacher,
} from "@/assets/js/globalTypes";
import { $t } from "@/i18n";
import { useSuperAdminStore } from "@/store/superadmin";
import { useTeacherStore } from "@/store/teacher";
import type { DataTablePageEvent } from "primevue/datatable";
defineOptions({
	name: "admin.teachers.pending",
});
definePage({
	name: "admin.teachers.pending",
	meta: {
		hasKeepAlive: ["admin.teachers.profile"],
		permissions: "view-teacher-management",
		readableName: "Pending validations",
	},
});

const router = useRouter();
const route = useRoute();
const teacherStore = useTeacherStore();

const currentPage = computed(() => {
	return router.currentRoute.value.query.page;
});

const superAdminStore = useSuperAdminStore();
const rows = ref(10);
const filter = ref<TFilterObject>();
const teachers = ref([]);
const pagination = ref<TPagination>();
const filterOptions = ref<TFilterObject[]>([
	{
		label: $t("app.admin.teacher.filterOptions.pendingRegistration"),
		value: 1,
	},
	{ label: $t("app.admin.teacher.filterOptions.profileUpdate"), value: 2 },
]);
const isLoading = ref(false);

onActivated(() => {
	getTeachers();
});
onBeforeMount(() => {
	getTeachers();
});

watch(
	() => currentPage.value,
	() => {
		getTeachers();
	},
);

const getTeachers = async () => {
	try {
		isLoading.value = true;
		const params = {
			page: Number(currentPage.value) || 1,
			per_page: rows.value || 20,
			usr_fullname: superAdminStore.teacherName,
			status: filter.value?.value,
		};
		const response = await teacherStore.fetchPendingTeachers(params);
		teachers.value = response.data;
		pagination.value = response.meta.pagination;
		if (
			pagination.value &&
			Number(pagination.value.current_page) >
				Number(pagination.value.total_pages)
		) {
			router.push({
				query: {
					...route.query,
					page: pagination.value.total_pages,
				},
			});
		}
		isLoading.value = false;
	} catch (error) {
		console.error(error);
	}
};

const resetPage = () => {
	router.replace({
		query: {
			...route.query,
			page: 1,
		},
	});
};

const updateRows = (row: number) => {
	if (row === rows.value) return;
	rows.value = row;
	getTeachers();

	// if (currentPage.value === "1") {
	// 	getTeachers();
	// } else {
	// 	resetPage();
	// }
};

const changePage = (event: DataTablePageEvent) => {
	router.push({
		query: {
			...route.query,
			page: event.page + 1,
		},
	});
};

const handleFilter = (filterOption: TFilterObject) => {
	filter.value = filterOption;
	if (currentPage.value === "1") {
		getTeachers();
	} else {
		resetPage();
	}
};

const handleSearch = (search: string) => {
	superAdminStore.teacherName = search;
	if (currentPage.value === "1") {
		getTeachers();
	} else {
		resetPage();
	}
};

const handleReview = (data: TTeacher) => {
	router.push({
		name: "admin.teachers.profile",
		params: {
			id: data.usr_id,
		},
	});
};
</script>

<template>
	<div id="admin-teachers-pending">
		<TeacherTable
			v-if="!isLoading"
			:title="$t('app.teacher.pendingTitle')"
			:teachers="teachers"
			:filter-options="filterOptions"
			:uses-created-date="false"
			:alt-preview="false"
			:rows="rows"
			:page="Number(currentPage || 1)"
			:total-records="pagination.total"
			:filter="filter"
			@filter="handleFilter"
			@search="handleSearch"
			@update:page="changePage"
			@update:rows="updateRows"
			@table-action="handleReview"
		>
			<!-- :total-records="pagination?.total" -->
			<!-- <template #action="slotProps">
				<p-button
					variant="outlined"
					:label="$t('app.base.review')"
					@click="handleReview(slotProps.data)"
				/>
			</template> -->
		</TeacherTable>
	</div>
</template>

<style scoped lang="scss"></style>
